import api from '~/api'
import get from 'lodash/get'
import debounce from 'lodash/debounce'
import { Notification } from 'element-ui'

const state = {
  providers: [],
  providersList: [],
  providerSearching: false,
}

const getters = {
  provider: s => id => s.providers.find(provider => provider.id === id),
  providers: s => s.providers,
}

const mutations = {
  SET_PROVIDERS(state, providers) {
    state.providers = providers
  },
  SET_PROVIDERS_LIST(state, payload) {
    state.providersList = payload
  },
  SET_SEARCHING(state, payload) {
    state.providerSearching = payload
  },
}

const actions = {
  async GET_PROVIDERS({ commit }, form) {
    const providers = await api.get('/providers')
    const [error, response] = providers

    if (!error) {
      commit('SET_PROVIDERS', response.items)
    }

    return providers
  },
  POST_PROVIDER(_, form) {
    return api.post('/providers', form)
  },
  GET_PROVIDER(_, id) {
    return api.get(`/providers/${id}`)
  },
  PUT_PROVIDER(_, form) {
    return api.put(`/providers/${form.id}`, form)
  },
  DELETE_PROVIDER(_, id) {
    return api.delete(`/providers/${id}`)
  },
  searchProviders: debounce(async function({ commit }, string) {
    commit('SET_SEARCHING', true)
    const [error, success] = await api.post(
      '/search/providers/_search?from=0&size=10',
      {
        query: {
          wildcard: { 'name.lowercase': `*${String(string)}*` },
        },
      }
    )

    let providersList = []

    if (error) {
      commit('SET_PROVIDERS_LIST', [])
      Notification({
        type: 'error',
        title: 'Error',
        message: error.message,
      })
    } else if (success) {
      providersList = get(success, 'hits.hits', []).map(item => {
        return { label: item._source.name, value: item._id }
      })
      commit('SET_PROVIDERS_LIST', providersList)
    }
    commit('SET_SEARCHING', false)
    return [error, providersList]
  }, 300),
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
